import { Injectable } from '@angular/core';
import { HttpParams, HttpClient } from '@angular/common/http';
import { globals } from '../globals';
import { VendaPergunta } from '../models/venda-pergunta';

@Injectable({
  providedIn: 'root'
})
export class QuestionarioService {

  constructor(private http: HttpClient) { }

  consultarComPaginacao(descri: string, paginaAtual, qtdRegistros, campoOrdenacao, orientacaoOrdenacao, tipoQuest, status) {

    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao)
      .set('tipoQuest', tipoQuest.toString())
      .set('status', status.toString());

    if (descri.length > 0) {
      parametros = parametros.set('descri', descri);
    }

    return this.http.get<any>(globals.apiUrl + '/api/VendaPergunta/ListaPag',
      {
        params: parametros
      });
  }

  consultarLista(tipoQuest = null) {
    let parametros = new HttpParams();

      if (tipoQuest != null && tipoQuest != undefined) {
        parametros = parametros.set('tipoQuest', tipoQuest.toString());
      }

    return this.http.get<any>(globals.apiUrl + '/api/VendaPergunta/Lista',
      { params: parametros });
  }

  consultarPorId(id: number) {
    return this.http.get<any>(globals.apiUrl + '/api/VendaPergunta/Buscar',
      { params: new HttpParams().set('id', id.toString()) });
  }

  salvar(vm: VendaPergunta) {
    return this.http.post(globals.apiUrl + '/api/VendaPergunta/Salvar', vm);
  }

  excluir(id: number) {
    return this.http.delete(globals.apiUrl + '/api/VendaPergunta/Excluir',
      { params: new HttpParams().set('id', id.toString()) });
  }
}
